import type { App as VueApp, Component } from "vue";

import PrimeVue from "primevue/config";
import Aura from "@primeuix/themes/aura";
import ToastService from "primevue/toastservice";
import ConfirmationService from "primevue/confirmationservice";

import Dialog from "primevue/dialog";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import MultiSelect from "primevue/multiselect";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import ColumnGroup from "primevue/columngroup";
import Row from "primevue/row";
import DatePicker from "primevue/datepicker";
import Checkbox from "primevue/checkbox";
import ToggleSwitch from "primevue/toggleswitch";
import Card from "primevue/card";
import SpeedDial from "primevue/speeddial";
import Textarea from "primevue/textarea";
import Panel from "primevue/panel";
import Select from "primevue/select";
import Slider from "primevue/slider";
import ScrollPanel from "primevue/scrollpanel";
import InputNumber from "primevue/inputnumber";
import Listbox from "primevue/listbox";
import SelectButton from "primevue/selectbutton";
import Menu from "primevue/menu";
import TreeTable from "primevue/treetable";
import FileUpload from "primevue/fileupload";
import RadioButton from "primevue/radiobutton";
import ConfirmPopup from "primevue/confirmpopup";
import ProgressSpinner from "primevue/progressspinner";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import AccordionPanel from "primevue/accordionpanel";
import AccordionHeader from "primevue/accordionheader";
import AccordionContent from "primevue/accordioncontent";
import ProgressBar from "primevue/progressbar";
import Message from "primevue/message";
import FloatLabel from "primevue/floatlabel";
import InlineMessage from "primevue/inlinemessage";
import SplitButton from "primevue/splitbutton";
import PickList from "primevue/picklist";
import DataView from "primevue/dataview";
import Menubar from "primevue/menubar";
import Tag from "primevue/tag";
import Badge from "primevue/badge";
import InputIcon from "primevue/inputicon";
import IconField from "primevue/iconfield";
import Drawer from "primevue/drawer";
import Fieldset from "primevue/fieldset";
import OverlayBadge from "primevue/overlaybadge";
import Paginator from "primevue/paginator";
import AutoComplete from "primevue/autocomplete";
import Chip from "primevue/chip";
import { Form } from "@primevue/forms";
import Password from "primevue/password";
import ConfirmDialog from "primevue/confirmdialog";
import Divider from "primevue/divider";
import PanelMenu from "primevue/panelmenu";
import BadgeDirective from "primevue/badgedirective";
import Tooltip from "primevue/tooltip";
import Tree from "primevue/tree";
import Tabs from "primevue/tabs";
import TabList from "primevue/tablist";
import Tab from "primevue/tab";
import TabPanels from "primevue/tabpanels";
import TabPanel from "primevue/tabpanel";
import Splitter from "primevue/splitter";
import SplitterPanel from "primevue/splitterpanel";
import Rating from "primevue/rating";
import Image from "primevue/image";

import "primeflex/primeflex.css";
import "primeicons/primeicons.css";

const components: Record<string, Component> = {
  Dialog,
  Button,
  InputText,
  MultiSelect,
  DataTable,
  Column,
  ColumnGroup,
  Row,
  DatePicker,
  Checkbox,
  ToggleSwitch,
  Card,
  SpeedDial,
  Textarea,
  Panel,
  Select,
  Slider,
  ScrollPanel,
  InputNumber,
  Listbox,
  SelectButton,
  Menu,
  TreeTable,
  FileUpload,
  RadioButton,
  ConfirmPopup,
  ProgressSpinner,
  Accordion,
  AccordionTab,
  AccordionPanel,
  AccordionHeader,
  AccordionContent,
  ProgressBar,
  Message,
  InlineMessage,
  SplitButton,
  PickList,
  DataView,
  Menubar,
  Tag,
  Badge,
  InputIcon,
  IconField,
  Drawer,
  FloatLabel,
  Fieldset,
  OverlayBadge,
  Paginator,
  AutoComplete,
  Chip,
  Form,
  Password,
  ConfirmDialog,
  PanelMenu,
  Divider,
  Tree,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Splitter,
  SplitterPanel,
  Rating,
  Image,
};

export function installPrimeVue(app: VueApp) {
  console.log("installPrimeVue called");
  app.use(PrimeVue, {
    theme: {
      preset: Aura,
      options: {
        darkModeSelector: false,
        cssLayer: {
          name: "primevue",
          order: "theme, base, primevue",
        },
      },
    },
  });

  app.use(ToastService);
  app.use(ConfirmationService);

  Object.entries(components).forEach(([name, component]) => {
    app.component(name, component);
  });

  app.directive("badge", BadgeDirective);
  app.directive("tooltip", Tooltip);
}
